<template>
  <v-row
    justify="space-around"
    class="ma-4"
    v-if="Object.keys(dashboardStats).length"
  >
    <v-col
      cols="auto"
      mr-auto
      v-for="(stats, index) in dashboardStats"
      :key="index"
    >
      <v-hover v-slot:default="{ hover }">
        <v-card
          :elevation="hover ? 6 : 1"
          class="pointed-cursor text-center"
          height="110px"
          width="110px"
          outlined
          ripple
          :class="{
            active: selectedStat.tag_id === stats.tag_id
          }"
          @click="filterForms(stats)"
        >
          <v-card-title class="justify-center">
            <div class="subtitle-2">{{ stats.display_name }}</div>
          </v-card-title>
          <div class="display-1">{{ stats.count }}</div>
        </v-card>
      </v-hover>
    </v-col>
  </v-row>

  <!-- <v-row justify="space-between" class="ma-4" v-else>
    <v-col sm="1.5" v-for="i in 6" :key="i">
      <app-skeleton :type="'image'" :height="'110px'" />
    </v-col>
  </v-row> -->
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { EventBus } from '@/eventBus.js'
import uiHelper from '@/helpers/ui'

export default {
  name: 'DashboarStatsFilters',

  components: {
    // AppSkeleton: () => import('@/components/AppSkeleton')
  },

  data() {
    return {
      selectedStat: {
        tag_id: this.dashboardDefaultTagId
      }
    }
  },

  computed: {
    ...mapGetters({
      dashboardStats: 'user/dashboardStats',
      dashboardDefaultTagId: 'form/dashboardDefaultTagId'
    })
  },

  mounted() {
    this.filterForms({ tag_id: this.dashboardDefaultTagId })
    EventBus.$on('getUpdatedDashboardForms', () => {
      this.filterForms({ tag_id: this.dashboardDefaultTagId })
    })
    EventBus.$on('changeForm', () => this.onChangeForm())
  },
  beforeDestroy() {
    EventBus.$off('getUpdatedDashboardForms')
    EventBus.$off('changeForm')
  },

  methods: {
    ...mapMutations({
      setSubmissionPageNumber: 'form/setSubmissionPageNumber',
      clearAllSubmissions: 'form/clearAllSubmissions',
      setSelectedStats: 'form/setSelectedStats'
    }),

    ...mapActions({
      getOpenSubmissions: 'form/getOpenSubmissions'
    }),

    async filterForms(stats) {
      uiHelper.progressBarStatus(true)
      this.selectedStat = stats
      this.setSelectedStats(stats)
      this.setSubmissionPageNumber(1)
      this.clearAllSubmissions()
      await this.getOpenSubmissions({ tagId: stats.tag_id })
      uiHelper.progressBarStatus(false)
    },
    onChangeForm() {
      this.selectedStat.tag_id = this.dashboardDefaultTagId
    }
  }
}
</script>

<style>
.active {
  background-color: var(--v-primary-lighten1) !important;
  color: #fff !important;
}
</style>
